import Vue from "vue";

import request from "../../helpers/request.js";

const state = Vue.observable({
    items: [],
    discount: null,
    discountCode: null,
    subTotal: null,
    total: null,
    loading: false
});

export const load = async () => {
    // set loading state
    state.loading = true;

    // get cart from API
    const response = await request.get(`${CART_API_URL}/list`);

    // reset loading state
    state.loading = false;

    // refresh cart
    return refreshCart(response);
};

export const addItem = async (productId, quantity) => {
    // set loading state
    state.loading = true;

    // add product to cart
    const response = await request.post(`${CART_API_URL}/add`, {
        productId,
        quantity
    });

    // reset loading state
    state.loading = false;

    // refresh cart
    return refreshCart(response);
};

export const updateItem = async (id, quantity) => {
    // set loading state
    state.loading = true;

    // update item quantity
    const response = await request.put(`${CART_API_URL}/update`, {
        id,
        quantity
    });

    // reset loading state
    state.loading = false;

    // refresh cart
    return refreshCart(response);
};

export const removeItem = async (id) => {
    // set loading state
    state.loading = true;

    // update item quantity
    const response = await request.delete(`${CART_API_URL}/remove`, {
        data: {
            id
        }
    });

    // reset loading state
    state.loading = false;

    // refresh cart
    return refreshCart(response);
};

export const addDiscount = async (code) => {
    // set loading state
    state.loading = true;

    // apply discount
    const response = await request.post(`${CART_API_URL}/add-discount`, {
        code
    });

    // reset loading state
    state.loading = false;

    // refresh cart
    return refreshCart(response);
};

export const removeDiscount = async (code) => {
    // set loading state
    state.loading = true;

    // remove discount
    const response = await request.post(`${CART_API_URL}/remove-discount`, {
        code
    });

    // reset loading state
    state.loading = false;

    // refresh cart
    return refreshCart(response);
};

const refreshCart = (res) => {
    state.items = res.data.items;
    state.discount = res.data.discount;
    state.discountCode = res.data.discountCode;
    state.subTotal = res.data.subTotal;
    state.total = res.data.total;
};

export default {
    state: state,
    load: load,
    add: addItem,
    update: updateItem,
    remove: removeItem,
    addDiscount: addDiscount,
    removeDiscount: removeDiscount
};